import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaWhatsapp, FaTimes, FaTelegramPlane } from "react-icons/fa";
import { useContactInfo } from "../../hooks/useData";

import ReactGA from "react-ga4";

const WhatsAppButton = () => {
  const contact = useContactInfo();
  const [isOpen, setIsOpen] = useState(false);

  const handleWhatsAppClick = (message = "") => {
    const defaultMessage = "Hello! I'm interested in your software solutions.";
    const finalMessage = message || defaultMessage;

    // Track Event
    ReactGA.event({
      category: "Contact",
      action: "WhatsApp Click",
      label: finalMessage,
    });

    window.open(
      `https://wa.me/${contact.whatsapp}?text=${encodeURIComponent(finalMessage)}`,
      "_blank",
    );
    setIsOpen(false);
  };

  const quickMessages = [
    {
      text: "I want to know about Commission Agent Software",
      product: "commission-agent",
    },
    {
      text: "I need Petrol Pump Management System",
      product: "petrol-pump",
    },
    {
      text: "Tell me about Library Management System",
      product: "library",
    },
    {
      text: "I want to become a Reseller",
      product: "reseller",
    },
  ];

  return (
    <>
      <div className="fixed bottom-6 right-6 z-[9999] flex flex-col items-end gap-4">
        <AnimatePresence>
          {isOpen && (
            <>
              {/* Overlay for mobile mainly */}
              <motion.div
                className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[9998]"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={() => setIsOpen(false)}
              />

              <motion.div
                className="bg-white rounded-3xl shadow-2xl p-5 w-[320px] sm:w-[350px] relative z-[9999] border border-gray-100"
                initial={{ opacity: 0, scale: 0.8, y: 20, x: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0, x: 0 }}
                exit={{ opacity: 0, scale: 0.8, y: 20, x: 20 }}
                transition={{ type: "spring", stiffness: 300, damping: 25 }}
              >
                <div className="flex items-center justify-between mb-4 pb-4 border-b border-gray-100">
                  <div className="flex items-center gap-2">
                    <div className="w-10 h-10 rounded-full bg-green-500 flex items-center justify-center text-white">
                      <FaWhatsapp size={20} />
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900 leading-tight">
                        M.S Support
                      </h3>
                      <p className="text-xs text-green-500 font-medium">
                        ● Online
                      </p>
                    </div>
                  </div>
                  <button
                    className="p-2 rounded-full hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-colors"
                    onClick={() => setIsOpen(false)}
                    aria-label="Close"
                  >
                    <FaTimes />
                  </button>
                </div>

                <div className="space-y-3 mb-4">
                  <p className="text-sm text-gray-500 mb-2">
                    Hello! 👋 How can we help you today?
                  </p>
                  {quickMessages.map((msg, index) => (
                    <motion.button
                      key={index}
                      className="w-full text-left p-3 rounded-xl bg-gray-50 hover:bg-green-50 text-gray-700 hover:text-green-700 text-sm font-medium transition-colors border border-gray-100 hover:border-green-200"
                      onClick={() => handleWhatsAppClick(msg.text)}
                      whileHover={{ scale: 1.02, x: 2 }}
                      whileTap={{ scale: 0.98 }}
                      initial={{ opacity: 0, x: -10 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: index * 0.05 }}
                    >
                      {msg.text}
                    </motion.button>
                  ))}
                </div>

                <button
                  className="w-full py-3 bg-green-500 hover:bg-green-600 text-white rounded-xl font-bold transition-colors flex items-center justify-center gap-2 shadow-lg shadow-green-200"
                  onClick={() => handleWhatsAppClick()}
                >
                  <FaTelegramPlane /> Start Chat
                </button>

                <div className="text-center mt-3">
                  <p className="text-[10px] text-gray-400">
                    Powered by Muskan Softwares
                  </p>
                </div>
              </motion.div>
            </>
          )}
        </AnimatePresence>

        <motion.button
          className="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-green-500 text-white flex items-center justify-center shadow-lg shadow-green-500/30 hover:bg-green-600 transition-colors relative z-[9999]"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="WhatsApp Support"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 200, damping: 15 }}
        >
          <FaWhatsapp className="text-2xl sm:text-3xl" />

          {!isOpen && (
            <span className="absolute top-0 right-0 w-4 h-4 bg-red-500 rounded-full border-2 border-white animate-pulse" />
          )}
        </motion.button>
      </div>
    </>
  );
};

export default WhatsAppButton;
